import {Element} from "react-scroll";
import ImageSlider from "./ImageSlider";
import {Card, CardBody, Container} from "reactstrap";
import React from "react";
import {useTranslation} from "react-i18next";

const images = [
    "/references/1.jpg",
    "/references/2.jpg",
    "/references/3.jpg",
    "/references/4.jpg",
    "/references/5.jpg",
    "/references/6.jpg",
    "/references/7.jpg",
    "/references/8.jpg",
    "/references/9.jpg",
    "/references/10.jpg",
    "/references/11.jpg",
    "/references/12.jpg",
    "/references/13.jpg",
    "/references/14.jpg",
    "/references/15.jpg",
    "/references/16.jpg",
    "/references/17.jpg",
    "/references/18.jpg",
    "/references/19.jpg",
    "/references/20.jpg",
    "/references/21.jpg",
    "/references/22.jpg",
    "/references/23.jpg"
]

function References() {
    const {t} = useTranslation();
    return (
        <Element name="references">
            <Container className="my-5">
                <Card className="shadow-lg rounded-4 border-0">
                    <CardBody className="p-2">
                        <h2 className="text-center text-success mb-2">{t("references")}</h2>
                        <ImageSlider images={images} slidesToShow={3} height={550} />
                    </CardBody>
                </Card>
            </Container>
        </Element>
    )
}

export default References;